import React, { Suspense, lazy, useEffect, useState } from "react"
import LayoutDumpster from "../components/layout-dumpster"
import Container from "../components/layout/container"
import Content from "../components/content/Content"
import Sidebar from "../components/content/Sidebar";
import Box from "../components/content/Box";
import SchemaStars from "../components/schemastars"
import Stars from "../components/stars"
import Anchor from "../components/content/Anchor";
import Lightbox from "../components/content/Lightbox";
import TextWithTeaser from "../components/content/TextWithTeaser";
import ServiceModalSelect from "../components/service-select-modal"
import QuoteRequestModalLibrary from "../components/quote-request-modal-library"
import {ApolloClient, InMemoryCache, HttpLink} from '@apollo/client'
import {GET_PAGINATION_REVIEWS} from '../components/paginationQueryDefinition'
import Pagination from "../components/pagination";
import ServiceSeekerComponent from "../components/content/ServiceSeekerComponent";
import { trackBookingSubmission, trackSimpleEvent } from "../helpers/helpers";
// import ReactDOMServer from "react-dom/server"

const OnlineBooking = lazy(() => import('@hometown/react-hometown-lib').then((module) => ({default: module.OnlineBooking})));

const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
}

const defaultTabs = [
    {
        value: 'overview',
        label: 'Overview',
    },
    {
        value: 'photos',
        label: 'Photos',
    },
    {
        value: 'reviews',
        label: 'Reviews',
    },
]

const PROFILELANDINGPAGEDUMPSTER = ({ pageContext }) => {
    const page = pageContext
    const code = page.code
    const env = page.env
    const profile = page.profile
    const posts = page.reviews
    const paginationInfo = pageContext.pagination; 
    const permanentlyClosed = profile.profile.permanentlyClosed;

    // const apolloService = "http://localhost:4000/api/v1"
    const apolloService = `${process.env.GATSBY_BOOKABLE_SERVICE_API}`;
    const googlePlaceAutocompleteApiKey = `${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`;
    const gatsbyKey = pageContext.gatsbyKey;
    const [bookingInitialData, setBookingInitialData] = useState();
    const [showBooking, setShowBooking] = useState(false)
    const [selectedTab, setSelectedTab] = useState(profile.hideServiceSeeker === false ? 'service-seeker' : 'overview');
    const [showMore, setShowMore] = useState(false);
    const [reviews, setReviews] = useState(posts)
    const [pagination, setPagination] = useState(paginationInfo);
    const [showPhone, setShowPhone] = useState(false);
    const [isBack, setIsBack] = useState(false);

    const isProSponsored = (proData) => {
        return proData?.db && Number(proData.db) > 0;
    };

    const showDefaultPlaces = () => {
        let auxArr = [];
        profile.areas?.forEach(area => {
            auxArr.push({ state: area.state, status: false })
        })
        return auxArr;
    }
    const [showPlaces, setShowPlaces] = useState(showDefaultPlaces());

    let defaultTemplateName;
    let defaultServiceId;
    const formatDefaultData = () => {
        if(profile.hideServiceSeeker === false){
            let localData;
            let sessionData;
            if(typeof window !== 'undefined'){ 
                localData = JSON.parse(localStorage.getItem('onlineBookingData'));
                sessionData = JSON.parse(sessionStorage.getItem('service-detail'));
            }
            if (sessionData?.templateName && sessionData?.serviceId) {
                defaultTemplateName = sessionData.templateName;
                defaultServiceId = sessionData.serviceId
            }
            if(localData){
                if(localData.finalDataForBooking) {
                    const data = localData.finalDataForBooking
                    let address = data.find(element => element.key === 'fullFormData').value
                    if(address) {
                        address = JSON.parse(address)
                        let addressObj = {}
                        address.forEach(e => addressObj[e[0]] = e[1])
                        let wasteType = data.find(element => element.key === 'wasteType').value
                        let obj = {
                            "odf_country": addressObj.country,
                            "odf_locality": addressObj.locality,
                            "odf_place_id": addressObj.place_id,
                            "odf_postal_code": addressObj.postal_code,
                            "odf_state": addressObj.state,
                            "odf_street": addressObj.street,
                            "odf_street2": addressObj.street2,
                            "wasteType": wasteType,
                        }
                        return obj
                    }
                }else {
                    return localData.initialValues?.find(data => data.key === 'fullFormData')?.value
                }
            }
            else if(profile.serviceSeekerData){
                return {"wasteType": `${profile.serviceSeekerData.wasteType}`}
            }
            else{
                return {"wasteType": "1"}
            }
        }
    }

    const [formSubmitData, setFormSubmitData] = useState(formatDefaultData());
    const [templateName, setTemplateName] = useState(defaultTemplateName || 'card-list');
    const [serviceId, setServiceId] = useState(defaultServiceId);
    const [isVisible, setIsVisible] = useState(defaultTemplateName ? false : true);

    const headers = {};
    headers['Ocp-Apim-Subscription-Key'] = process.env.GATSBY_API_MANAGMENT_KEY;

    let tabs = defaultTabs;
    if(profile.hideServiceSeeker === false) {
        tabs = [
            {
                value: 'service-seeker',
                label: 'Book Now', 
            },
            ...tabs
        ]
    }

    if(profile.photos?.length === 0){
        tabs = tabs.filter(tab => tab.value !== 'photos')
    }
    
    useEffect(() => {
        const pro = profile?.profile;

        if (!pro?.id || pro?.db === undefined || pro?.db === null) return;
        const sponsored = isProSponsored(pro);
        const proId = pro.id;
        if (sponsored) {
            trackSimpleEvent("sponsoredProPageVisible", proId);
        } else {
            trackSimpleEvent("proPageVisible", proId);
        }

    }, [profile?.profile?.id, profile?.profile?.db])

    // visibility of th price & book button
    useEffect(() => {
        (async () => {
            const contentDiv = document.getElementById("service-seeker-container");
            if(profile.hideServiceSeeker === false){
                const localData = JSON.parse(localStorage.getItem('onlineBookingData'));
                if(localData){
                    if(localData.finalDataForBooking) formatData(localData.finalDataForBooking)
                    else setFormSubmitData(localData.initialValues?.find(data => data.key === 'fullFormData')?.value)
                }
                if(contentDiv?.classList.contains("display-none")){
                    contentDiv.classList.remove("display-none");
                }
            }else{
                if(!contentDiv?.classList.contains("display-none")){
                    contentDiv.classList.add("display-none");
                }
            }
            window.addEventListener('scroll', () => showScrollTop(tabs));
            return () => window.removeEventListener('scroll', () => showScrollTop(tabs));
        })()
    }, [])

    const serviceSeekerCallback = (data) => {
        const template = data?.find(element => element.key === 'template')
        if(template){
            setTemplateName(template.value);
            const serviceid = data?.find(element => element.key === 'service')
            if(serviceid) {
                setServiceId(serviceid.value?.id);
            }
        } else {
            setTemplateName('card-list');
            setServiceId();
        }
        formatData(data);
        setBookingInitialData(data)
        setShowBooking(!showBooking);
    }

    const handleBackOnlineBooking = (data) => {
        formatData(data)
        setShowBooking(!showBooking);
        setIsBack(true)
    }

    const formatData = (data) => {
        let address = data.find(element => element.key === 'fullFormData').value
        if(address) {
            address = JSON.parse(address)
            let addressObj = {}
            address.forEach(e => addressObj[e[0]] = e[1])
            let wasteType = data.find(element => element.key === 'wasteType').value
            let obj = {
                "odf_country": addressObj.country,
                "odf_locality": addressObj.locality,
                "odf_place_id": addressObj.place_id,
                "odf_postal_code": addressObj.postal_code,
                "odf_state": addressObj.state,
                "odf_street": addressObj.street,
                "odf_street2": addressObj.street2,
                "wasteType": wasteType,
                // "date": data.find(element => element.key === 'date').value
            }
            setFormSubmitData(obj)
        }
    }

    const handleScrollTo = () => {
        let addressField = document.getElementById('online-booking-address')
        if(addressField){
            const headerOffset = 130;
            const elementPosition = addressField.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;
        
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
            addressField.focus();
        }
    }

    let servicesObj = {};
    let proId = page.profile.profile.id
    page.profile.services[0].forEach(element => {
        if(element.name !== 'Demolition') {
            let ondeffCode = 'priceAndAvailabilityForm';
            if (element.name == "Junk Removal") {
                ondeffCode = 'junkRemovalQuoteRequest';
            } else if (element.name == "Commercial Trash Service") {
                ondeffCode = 'commercialWasteQuoteRequest';
            }
            servicesObj[element.name] = ondeffCode;
        }
    });

    // SEO for meta tags 

    const SERVICE_PRIORITY = [
        'Dumpster Rental',
        'Junk Removal',
        'Commercial Trash Service',
    ];

    const getPrimaryService = (profile) => {
        const services = profile.services?.[0] || [];
        const serviceNames = services.map(s => s.name);

        return SERVICE_PRIORITY.find(p => serviceNames.includes(p)) || 'Dumpster Rental';
    };

    const getSeoCities = (profile, limit = 3) => {
        const cities = profile.areas?.flatMap(area => area.places || []) || [];
        
        return cities.slice(0, limit).map(city => city.split(',')[0]);
    };


    const getSeoTitle = (profile) => {
        const service = getPrimaryService(profile);
        const city = profile.profile.add_c;
        const state = profile.profile.add_av;
        const name = profile.name;

        switch (service) {
            case 'Junk Removal':
                return `${name} - ${city}, ${state} Junk Removal`;

            case 'Commercial Trash Service':
                return `${name} - ${city}, ${state} Commercial Trash Service`;

            case 'Dumpster Rental':
            default:
                return `${name} - ${city}, ${state} Dumpsters for Rent`;
        }
    };

    const getSeoDesc = (profile) => {
        const service = getPrimaryService(profile);
        const name = profile.name;
        const cities = getSeoCities(profile).join(', ');

        switch (service) {
            case 'Junk Removal':
                return `Get affordable cleanouts and junk pickup from ${name}. Full-service junk removal in ${cities} & nearby.`;

            case 'Commercial Trash Service':
                return `Get affordable commercial trash pickup from ${name} in ${cities} & nearby. Get a quote and save on monthly rates.`;

            case 'Dumpster Rental':
            default:
                return `Get dumpster rental pricing and availability for ${name}. Easy online booking & same day/next day delivery to ${cities} and nearby.`;
        }
    };



    const seoImage = (image) => {
        if (image.path !== undefined) {
            return image.path
        }

        return false
    }
    
    const seo =
    {
        url: profile.url,
        env: env,
        title: getSeoTitle(profile),
        description: getSeoDesc(profile),
        code: code,
        page: 'profile',
        image: seoImage(profile.profile.logo),
        schema: page.schemaOrg
    }

    const BreadCrumb = () => {
        const links = profile.breadcrumb || [];

        if (links.length === 0) return null;
        
            return (
            <Container classes="bread">
                <div className="col-12 breadcrumb-scroll">
                    {links.map((link, index) => (
                        <React.Fragment key={`${link.url}-${index}`}>
                            <a
                            href={link.url}
                            title={link.html_title || link.label}
                            className="breadcrumb-link"
                            >
                                {link.label}
                            </a>
                
                            {index < links.length - 1 && (
                            <span className="breadcrumb-separator">{'>'}</span>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </Container>
        );
    };

    
    const ProCardBanner = () => {
        const rates = page.totalReviews;
        const services = profile.serviceslinks[0]

        const ServicesLinks = () => {
            services.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))

            return (
                <ul className="service_links">
                    {
                        services.map(service => {
                            if (service) {
                                return (
                                    <li><a href={service.url}>{service.label}</a></li>
                                )
                            }

                            return <></>
                        })
                    }
                </ul>
            )
        }

        const CompanyTags = () => {
            if(profile.profile && profile.profile.company_tags?.length > 0){
                return (
                    <ul class='company-tags'>
                        {profile.profile.company_tags.map((tag, index) => (
                            <li key={index}>{tag}</li>
                        ))}
                    </ul>
                )
            }
            return <></>
        }

        const imgUrl = (image) => {
            const img = image.localFile.publicURL !== null ? image.localFile.publicURL : ''
            let thumb = img

            if(image.localFile.childImageSharp !== null){
                if(image.localFile.childImageSharp !== undefined){
                    thumb = image.localFile.childImageSharp.gatsbyImageData.images.fallback.src
                }    
            }

            return thumb
        }

        const handleClick = () => {
            const btn = document.getElementsByClassName('lightbox-btn');
            if(btn?.length > 0){
                btn[0].click();
            }else{
                handleChangeTab({
                    value: 'photos',
                    label: 'Photos',
                });
            }
        }

        return (
            <div className="profile-banner">
                <div className="profile-banner">
                    <div className="row">
                        <div className="col-12">
                            <div className="post">
                                <div className={`top-content1${profile.photos?.length === 0 ? ' full-width' : ''}`}>
                                    <h1 className="main-title"><span>{profile.name}</span></h1>
                                    <h3>{profile.profile.address_alternative}</h3>
                                    <SchemaStars reviews={paginationInfo.totalCount} profile calculate={rates} page='profile'/>
                                    <ServicesLinks />
                                    <CompanyTags />
                                    <div className="mobile-btn">
                                        <button className="btns" onClick={() => handleChangeTab({ value: 'reviews', label: 'Reviews' })}><span className="star-btn"/> Write a review</button>
                                        {profile.profile.phone && <a className="btns" href={'tel:' + profile.profile.phone}><span className="phone-btn" title="provider phone number"/> <span className="pro-phone-cont" data-proid={profile.profile.id}>Call</span></a>}
                                        {addWebsite("btns")}
                                    </div>
                                    { !profile.except ?
                                    <div className="actions">
                                        {Object.keys(servicesObj).length > 1 ?
                                            <ServiceModalSelect proid={proId} availableServices={servicesObj}/>
                                            : 
                                            ( Object.keys(servicesObj).length === 1 &&
                                            <QuoteRequestModalLibrary
                                                // showButton={true}
                                                startVisible={false}
                                                proid={proId}
                                                class="get-a-quote get-a-quote-profile-page"
                                                ondeffCode={Object.values(servicesObj)[0]}
                                                btnLabel="Get pricing & availability"
                                            />
                                            )
                                        }
                                    </div>
                                    : (profile.profile.phone &&
                                        <>
                                            <div className="phonemanager mobile">
                                                <span className="phone-btn" title="provider phone number"/>
                                                <strong><span className="phone" style={{fontSize: '20px'}}><a href={'tel:' + profile.profile.phone}><span className="pro-phone-cont" data-proid={profile.profile.id}>{profile.profile.phone}</span></a></span></strong>
                                            </div>
                                            <div className="phonemanager desktop" data-proid={profile.profile.id}>
                                                <span className="phone-btn" title="provider phone number"/>
                                                <strong><span className="phone" style={{fontSize: '20px'}}><a href={'tel:' + profile.profile.phone}><span className="pro-phone-cont" data-proid={profile.profile.id}>{profile.profile.phone}</span></a></span></strong>
                                            </div>
                                        </> 
                                    )
                                    }
                                </div >
                                {profile.photos?.length > 0 && profile.photos[0].localFile &&
                                <div className="top-content2" onClick={handleClick}>
                                    <div className="img-container">
                                        <img src={imgUrl(profile.photos[0])} alt={profile.photos[0].alt ? profile.photos[0].alt : profile.name}/>
                                        <div className="img-btn" onClick={handleClick}>
                                            {`See ${profile.photos.length} photos`}
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    const addWebsite = (c) => {
        const unpaid = profile.profile.unpaid;
        if (unpaid || profile.profile.website === '') return <></>

        const website = c ? 'Website' : (profile.profile.website.length > 35 ? 'Website' : profile.profile.website)

        return (
            <div className={c ? `websitemanager ${c}` : "websitemanager"}>

                <span className="web-btn" title="provider website"/>

                <span className="website"><a target="_blank" className="pro-website-cont" data-proid={profile.profile.id} href={profile.profile.website}><span className="pro-website-cont" data-proid={profile.profile.id}>{website}</span></a></span>

            </div>
        )
    }

    const SidebarCard = () => {
        const hideAddress = profile.profile.hide_address

        const addPhone = (phone) => {

            if (phone !== '') {
                return (
                    <>
                        <div className="phonemanager mobile">
                            <span className="phone-btn" title="provider phone number"/>
                            <span className="phone"><a href={'tel:' + phone}><span className="pro-phone-cont" data-proid={profile.profile.id}>Call</span></a></span>
                        </div>
                        <div className="phonemanager desktop" data-proid={profile.profile.id}>
                            <span className="phone-btn" title="provider phone number"/>
                            <span className="phone"><span className="on-click-phone" onClick={() => setShowPhone(true)}><span className="pro-phone-cont" data-proid={profile.profile.id}>{showPhone ? phone : 'View phone'}</span></span></span>
                        </div>
                    </>
                )
            }

            return <></>;
        }

        const addLogo = (image, name) => {
            if (image.path !== undefined) {
                return (
                    <div className="images" >
                        <div className="image-container">
                            <picture>
                                <source media="(min-width: 769px)" title={name + ' logo'}  srcset={image.path}/>
                                <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w" alt={name + ' logo'} loading="eager"/>
                            </picture>
                        </div>
                    </div>
                )
            }

            return (
                <div class='logo-container'>
                    <div class='logo-name'>
                        {/*Get the first two initial letters of the company name */}
                        {profile.name.match(/\b\w/g).join('').slice(0, 2)}
                    </div>
                </div>
            )
        }

        const addAddress = () => {
            if (hideAddress) {
                return (
                    <ul className="address">
                        {profile.profile.address_alternative && <li className="street"><span className="address-btn" title="provider address"/>  {profile.profile.address_alternative}</li>}
                    </ul>
                )
            }

            return (
                <ul className="address">
                    {profile.profile.address !== '' && <li className="street"><span className="address-btn" title="provider address"/>  {profile.profile.address}</li>}
                    {profile.profile.address_extras && <li className="region">{profile.profile.address_extras}</li>}
                </ul>
            )
        }

        return (
            <div className="info">
                {addLogo(profile.profile.logo, profile.name)}
                {addAddress()}
                <div className="phone_box">
                    {addPhone(profile.profile.phone)}
                </div>
                <div className="webiste_box">
                    {addWebsite()}
                </div>
                {!profile.except && Object.keys(servicesObj).length > 1 ? 
                    <ServiceModalSelect proid={proId} availableServices={servicesObj}/>
                    : 
                    ( Object.keys(servicesObj).length === 1 &&
                    <QuoteRequestModalLibrary
                        // showButton={true}
                        startVisible={false}
                        proid={proId}
                        class="get-a-quote get-a-quote-profile-page"
                        ondeffCode={Object.values(servicesObj)[0]}
                        btnLabel="Get pricing & availability"
                    />
                    )
                }
            </div>
        )
    }

    const Description = () => {
        if (profile.description === '') return <></>

        return (
            <div id='overview' className="profile-description">
                <h2>Description</h2>
                <Anchor name="profile" />
                <TextWithTeaser danger={true}>{profile.description}</TextWithTeaser>
            </div>
        )
    }

    const Services = () => {
        const services = profile.services[0].length > 0 ? profile.services[0] : []

        services.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))

        if (services.length <= 0) return <></>

        return (
            <div className="profile-services">
                <h2>Services</h2>
                <Anchor name="services" />
                <ul className="names">
                    {
                        services.map(service => {
                            return <li>{service.name}</li>
                        })
                    }
                </ul>
            </div>
        )
    }

    const Photos = () => {
        const photos = profile.photos

        if (photos.length <= 0) return <></>

        return (
            <div id='photos' className="profile-photos">
                <h2>Photos</h2>
                <Anchor name="photos" />
                <Lightbox images={profile.photos} globalt={profile.name} />
            </div>
        )
    }


    const PopularProsNearby = ({ pros }) => { 
        if (!pros || pros.length === 0) return null;

        return ( 
            <div className="popular-pros-nearby"> 
                <h2>Popular Pros Nearby</h2> 
                    {pros.map((pro) => ( 
                        <a key={pro.proId} href={pro.url} className="popular-pro-card sponsoredProCardNearMe" data-id={pro.proId} data-proid={pro.proId}>
                           {/* left: image */}
                            <div className="ppn-image">
                                {pro.uri ? (
                                    <img src={pro.uri} alt={pro.image_alt || pro.name} />
                                ) : (
                                    <div className="ppn-initials">{pro.pro_initials}</div>
                                )}
                            </div>                          
                            {/* right: info */}
                            <div className="ppn-info">
                                <h3 className="ppn-name">{pro.name}</h3>
                                <div className="ppn-address">{pro.address}</div>                          
                                {/* rating */}
                                {pro.stars  && (
                                    <SchemaStars reviews={pro.stars.total} profile calculate={pro.stars.rates} page='profile'/>
                                )}                            
                                {/* service tags */}
                                {pro.service_tags?.length > 0 && (
                                    <ul className="ppn-services">
                                        {pro.service_tags.map((tag, i) => (
                                            <li key={i}>{tag.name}</li>
                                        ))}
                                    </ul>
                                )}                            
                                {/* company tags */}
                                {pro.company_tags?.length > 0 && (
                                    <ul className="ppn-company-tags">
                                        {pro.company_tags.map((tag, i) => (
                                            <li key={i}>{tag.name}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </a> 
                    ))}
            </div> ); 
    };

    const Reviews = ({ proId }) => {
        const [currentPage, setCurrentPage] = useState(pagination?.currentPage)
        const [hasPreviousPage, setHasPreviousPage] = useState(pagination?.hasPreviousPage)
        const [hasNextPage, setHasNextPage] = useState(pagination?.hasNextPage)
        const [reviewsPerPage, setReviewsPerPage] = useState(20)
        const [lastPage, setLastPage] = useState(pagination?.pageCount)

        const headers = {};
        headers['Ocp-Apim-Subscription-Key'] = process.env.GATSBY_API_MANAGMENT_KEY;

        const client = new ApolloClient({
            link: new HttpLink({ uri: `${process.env.GATSBY_BOOKABLE_SEARCH_API}`,headers: headers}),
            cache: new InMemoryCache(),
            defaultOptions: defaultOptions
        })

        const getReviewTitle = (review) => {
            let str = '';
            if (review.customer === 'Name Withheld') {
                str = `Review from ${review.place}`;
            } else {
                str = `Review by ${review.customer}${(review.place === '' ? '' : ` in ${review.place}`)}`;
            }
            return str;
        }
      
        const makeQueryPagination = (page) => {
            let vars = {
                page: page,
                limit: reviewsPerPage,
                proId,
                site: env.site
            }
            client.query({
                query: GET_PAGINATION_REVIEWS,
                variables: vars
            }).then(result => {
                setReviews(result.data.paginationReviewsDefinition.posts)
                setLastPage(result.data.paginationReviewsDefinition.pageInfo.pageCount)
                setHasPreviousPage(result.data.paginationReviewsDefinition.pageInfo.hasPreviousPage)
                setHasNextPage(result.data.paginationReviewsDefinition.pageInfo.hasNextPage);
                setPagination(result.data.paginationReviewsDefinition.pageInfo);
            })
        }

        if (reviews.length <= 0)
            return (
                <div id='reviews' className="profile-reviews">
                    <h2>Verified Reviews</h2>
                    <Anchor name="reviews" />
                    <div className="write">
                        <div class="text">Be the first to add a review for {profile.name}</div>
                        <QuoteRequestModalLibrary
                            // showButton={false}
                            // showButtonForProfile={true}
                            startVisible={false}
                            proid={profile.profile.id}
                            ondeffCode= 'reviewForm'
                            btnLabel="Write a review"
                            class="profile-button-review-form"
                            title= {profile.profile.name} 
                            initialFormData={[{ key: 'pro_id', value: profile.profile.id }, { key: 'pro_name', value: profile.profile.name }]}
                        />
                    </div>
                </div>
            )

        return (
            <div id='reviews' className="profile-reviews">
                <h2>Verified Reviews</h2>
                <Anchor name="reviews" />
                <div className="write">
                    <span>{profile.name}</span>
                    <QuoteRequestModalLibrary
                        // showButton={false}
                        // showButtonForProfile={true}
                        startVisible={false}
                        proid={profile.profile.id}
                        ondeffCode= 'reviewForm'
                        btnLabel="Write a review"
                        class="profile-button-review-form"
                        title= {profile.profile.name} 
                        initialFormData={[{ key: 'pro_id', value: profile.profile.id }, { key: 'pro_name', value: profile.profile.name }]}
                    />
                </div>
                <div className="blogs">
                        {
                            reviews.map((review, index) => {
                                return (
                                    <div key={index} className="single-item review">
                                        <Stars rate={review.stars} page='profile'/>
                                        <div className="user">{getReviewTitle(review)}</div>
                                        <p>{review.text}</p>
                                    </div>
                                )
                            })
                        }
                </div>
                <Pagination class="pagination"
                    currentPage={currentPage}
                    hasPreviousPage={hasPreviousPage}
                    hasNextPage={hasNextPage}
                    lastPage={lastPage}
                    makeQueryPagination={makeQueryPagination}
                    setCurrentPage={setCurrentPage}
                    whoIsCalling='reviews'
                />
            </div>
        )
    }

    const Areas = () => {
        const areas = profile.areas;

        if (!areas || areas.length === 0) return <></>;

        if (profile.except) {
            return (
                <div className="profile-areas">
                    <h3>Areas We Serve</h3>
                    <p>Nationwide service area</p>
                </div>
            );
        }

        const cities = areas.flatMap(area => area.places);

        return (
            <div className="profile-areas service-area">
                <h3>Areas We Serve</h3>
                <p>We proudly serve these cities and surrounding communities.</p>
                <ul className="city-list">
                    {cities.map((city, index) => (
                        <li key={index}>{city}</li>
                    ))}
                </ul>
            </div>
        );
    };


    const handleChangeTab = (tab) => {
        setSelectedTab(tab.value);
        const element = document.getElementById(tab.value);
        const headerOffset = 130;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
    
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const TopMenu = () => {
        return (
            <div className='custom-tab-container col-8'>
            { tabs.map((tab) => (
                <React.Fragment
                    key={`tab-${tab.label}`}
                >
                    <div
                        key={`tab-${tab.label}`}
                        className='custom-tab'
                        onClick={() => {handleChangeTab(tab)}}
                    >
                        <p
                        className={selectedTab === tab.value ? 'tab-label active-tab' : 'tab-label'}
                        >
                        {tab.label}
                        </p>
                    </div>
                </React.Fragment>
                ))}
            </div>
        )
    }

    const showScrollTop = (tabs) => {
        let obj = {};
        tabs.forEach((tab,index) => {
            obj[index] = document.getElementById(tab.value)?.offsetTop;
        })
        const currentOffsetTop = window.scrollY + 150
        const lastItem = Object.keys(obj)?.length - 1;
        for(const property in obj){
            if(currentOffsetTop < obj[0]){
                setSelectedTab(tabs[0].value)
                break;
            }
            else if(currentOffsetTop > obj[property] && currentOffsetTop < obj[`${+property + 1}`]){
                setSelectedTab(tabs[property].value);
                break;
            }
            else if(currentOffsetTop > obj[lastItem]){
                setSelectedTab(tabs[lastItem].value)
                break;
            }            
        }     
    }

    const getProfileData = () => {
        return {
            "_attributes_id": profile.profile.id,
            n: profile.name,
            ur: profile.url,
            r: paginationInfo.totalCount,
            rt: page.ratingValue,
            d: profile.description,
            ct: profile.profile.company_tags?.join(','),
            a: profile.profile.address_alternative,
            ph: profile.profile.phone?.replace(/\D/g, ""),
            db: profile.profile.db
        }
    }   


    return (
        <LayoutDumpster seo={seo} env={env} bgcolor={'#f5f5f5'} hidden={true}>
            <div className="profile-landing-page" data-proid={profile.profile.id} id="profile-landing-page">
                {!showBooking && 
                <>
                    {isVisible &&
                    <>
                        <BreadCrumb />
                        <Container>
                            <Content width="col-12">
                                <Box>
                                    {permanentlyClosed && <p className="permanentlyClosedBanner rounded">Permanently closed</p>}
                                <ProCardBanner />
                                </Box>
                            </Content>
                        </Container>
                        <Container classes='menu-bar'>
                            <Content width="col-12">
                                <Box>
                                    <TopMenu />
                                </Box>
                            </Content>
                        </Container>
                    </>
                    }
                    <Container id="service-seeker-container" classes={profile.hideServiceSeeker != false ? "display-none" : (!isVisible ? "margin-details" : "")}>
                        <Content width="col-12">
                            <Box>
                            {profile.hideServiceSeeker === false && formSubmitData &&
                                <ServiceSeekerComponent
                                    proId={proId}
                                    formSubmitData={formSubmitData}
                                    googlePlaceAutocompleteApiKey={googlePlaceAutocompleteApiKey}
                                    serviceSeekerCallback={serviceSeekerCallback}
                                    defaultFilters={profile.serviceSeekerData?.defaultFilters}
                                    defaultServices={profile.serviceSeekerData?.defaultServices}
                                    isBack={isBack}
                                    gatsbyKey={gatsbyKey}
                                    templateName={templateName}
                                    serviceId={serviceId}
                                    profileData={getProfileData()}
                                    setIsVisible={setIsVisible}
                                />
                            }
                            </Box>
                        </Content>
                    </Container>
                    {isVisible &&
                    <Container>
                        <Content>
                            <Box>
                                <Description />
                                <Services />
                                <Photos />
                                {profile.popularProsNB?.length > 0 && ( 
                                    <PopularProsNearby pros={profile.popularProsNB} /> 
                                )}
                                <Reviews proId={pageContext.profile.profile.id}/>
                                <Areas />
                            </Box>
                        </Content>
                        <Sidebar>
                            <Box>
                                <SidebarCard />
                            </Box>
                        </Sidebar>
                    </Container>
                    }
                </>}
                {((profile.hideServiceSeeker === false) && showBooking) && (<Container>
                    <Content width="col-12">
                        <Box classes='order-container'>
                            <div id="online-booking" className="online-booking">
                                <Suspense fallback={<h1>Loading…</h1>}>
                                    <OnlineBooking
                                        handleBack={handleBackOnlineBooking}
                                        proId={proId} 
                                        proName={profile.name}
                                        apolloURL={apolloService}
                                        stripeApiKey={`${process.env.GATSBY_STRIPE_API_KEY}`}
                                        googlePlaceAutocompleteApiKey={googlePlaceAutocompleteApiKey}
                                        initialData={bookingInitialData} 
                                        proPhone={profile.profile.phone} 
                                        backUrl={`/${profile.url}`}
                                        gatsbyKey={gatsbyKey}
                                        label='Boton' 
                                        size='lg'
                                        staticUrl={`${process.env.GATSBY_SITE_DOMAIN}/assets/`}
                                        // staticUrl='https://hometownstaticsites.z19.web.core.windows.net/assets/'
                                        maxDatePicker={process.env.MAX_DATE_PICKER}
                                        // maxDatePicker={7776000000}
                                        trackBookingSubmission={trackBookingSubmission}
                                    />
                                </Suspense>
                            </div>
                        </Box>
                    </Content>
                </Container>)}
            </div>
        </LayoutDumpster>
    )
};

export default PROFILELANDINGPAGEDUMPSTER;